import { defineComponent as p } from "vue";
import { AssetLoader as _, buildComponents as b } from "@didi/fuxi-lowcode-vue-utils";
import v from "@didi/fuxi-lowcode-vue-renderer";
function $(n, e, i, s, o, a, l, u) {
  var r = typeof n == "function" ? n.options : n;
  e && (r.render = e, r.staticRenderFns = i, r._compiled = !0), s && (r.functional = !0), a && (r._scopeId = "data-v-" + a);
  var t;
  if (l ? (t = function(c) {
    c = c || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !c && typeof __VUE_SSR_CONTEXT__ < "u" && (c = __VUE_SSR_CONTEXT__), o && o.call(this, c), c && c._registeredComponents && c._registeredComponents.add(l);
  }, r._ssrRegister = t) : o && (t = u ? function() {
    o.call(
      this,
      (r.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : o), t)
    if (r.functional) {
      r._injectStyles = t;
      var f = r.render;
      r.render = function(m, h) {
        return t.call(h), f(m, h);
      };
    } else {
      var d = r.beforeCreate;
      r.beforeCreate = d ? [].concat(d, t) : [t];
    }
  return {
    exports: n,
    options: r
  };
}
const g = p({
  name: "FuxiLowcodeRender",
  props: {
    assets: {
      type: Object,
      default() {
        return {};
      }
    },
    schema: {
      type: Object,
      default() {
        return {};
      }
    },
    enableCache: {
      type: Boolean,
      default: !1
    },
    cacheLevel: {
      type: Number,
      default: 1
    },
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    VueRenderer: v
  },
  data() {
    return {
      pageSchema: null,
      components: null,
      messages: null
    };
  },
  async created() {
    await this.init();
  },
  methods: {
    async init() {
      try {
        const n = this.assets.packages, {
          componentsMap: e = [],
          componentsTree: i = [],
          i18n: s
        } = this.schema, o = {};
        e.forEach((r) => {
          o[r.componentName] = r;
        });
        const a = {}, l = [];
        n.forEach((r) => {
          const { package: t, library: f, urls: d, renderUrls: c } = r;
          a[t] = f, this.isNeedLoadAsset(r) && (c ? l.push(c) : d && l.push(d));
        }), this.$emit("load-start"), await new _().load(l);
        const u = await b(a, o);
        this.$emit("load-end"), this.messages = s, this.components = u, this.pageSchema = Object.freeze(i[0]), this.$emit("render-start"), this.$nextTick(() => {
          this.$emit("render-end");
        });
      } catch (n) {
        this.$emit("render-error", n.toString()), console.error(n);
      }
    },
    isNeedLoadAsset(n) {
      try {
        const e = window[n.library], i = (e == null ? void 0 : e.version) || (e == null ? void 0 : e.VERSION) || null, s = (n == null ? void 0 : n.version) || null;
        let o = !0;
        return o = !this.useCache(s, i), console.info(
          o ? `FuxiLowcodeRender: log => ${n.library} will load, load version: ${s}` : `FuxiLowcodeRender: log => ${n.library} use catch, use version: ${i} (Not loaded version: ${s})`
        ), o;
      } catch {
        return console.warn(
          `FuxiLowcodeRender: log => \u8D44\u4EA7\u5305\u7248\u672C\u5BF9\u6BD4\u5931\u8D25 ${n.library} will load, load version: ${(n == null ? void 0 : n.version) || null}`
        ), !0;
      }
    },
    useCache(n, e) {
      if (!this.enableCache || !n || !e)
        return !1;
      const i = this.cacheLevel, s = Number.isNaN;
      let [o, a, l] = n.split("."), [u, r, t] = e.split(".");
      if (o = Number(o), a = Number(a), l = Number(l), u = Number(u), r = Number(r), t = Number(t), s(o) || s(a) || s(l))
        throw new Error(`error => \u4F20\u5165\u7684\u7248\u672C\u4E0D\u5408\u6CD5 ${n}`);
      if (s(u) || s(r) || s(t))
        throw new Error(`error => \u4F20\u5165\u7684\u7248\u672C\u7248\u672C\u4E0D\u5408\u6CD5 ${e}`);
      return i === 3 && e === n || i === 2 && o === u && a === r && l <= t ? !0 : i === 1 && o === u && (a < r || a === r && l <= t);
    }
  }
});
var N = function() {
  var e = this, i = e._self._c;
  return e._self._setupProxy, e.pageSchema ? i("VueRenderer", e._b({ attrs: { schema: e.pageSchema, components: e.components, messages: e.messages } }, "VueRenderer", e.config, !1)) : e._e();
}, w = [], y = /* @__PURE__ */ $(
  g,
  N,
  w,
  !1,
  null,
  null,
  null,
  null
);
const C = y.exports, S = {
  FuxiLowcodeRender: C
};
export {
  S as default
};
